<template>
    <v-container fill-height fluid grid-list-xl class="pl-3 pt-2">
        <v-layout wrap>
            <v-flex xs12>
                <v-layout row>
                    <v-flex xs3>
                        <v-card
                            style="
                                border: 2px solid rgb(76, 175, 80);
                                box-shadow: 5px 5px 2px #c7ced8;
                                height: 100%;
                        "
                        >
                            <v-layout row justify-space-between>
                                <v-layout column class="ma-1 px-3">
                                    <v-card-text
                                        class="mb-0 pb-0 pt-3 pl-2"
                                        v-if="student && student.familyID"
                                    >
                                        <div
                                            class="display-1 font-weight-bold mb-0 ml-0"
                                        >
                                            {{
                                                student.hebName +
                                                    " " +
                                                    student.lastNameH
                                            }}
                                        </div>
                                        <div class="ml-0 mt-4">
                                            <div class="pl-3">
                                                <v-layout row class="mb-2">
                                                    <div
                                                        class="font-weight-medium mr-2"
                                                    >
                                                        Family ID:
                                                    </div>
                                                    <div>
                                                        {{ student.familyID }}
                                                    </div>
                                                </v-layout>
                                                <v-layout row class="mb-2">
                                                    <div
                                                        class="font-weight-medium mr-2"
                                                    >
                                                        Student ID:
                                                    </div>
                                                    <div>
                                                        {{ student.studentID }}
                                                    </div>
                                                </v-layout>
                                                <v-layout row class="mb-2">
                                                    <div
                                                        class="font-weight-medium mr-2"
                                                    >
                                                        Father:
                                                    </div>
                                                    <div>
                                                        {{ student.hname }}
                                                    </div>
                                                </v-layout>
                                                <v-layout row class="mb-2">
                                                    <div
                                                        class="font-weight-medium mr-2"
                                                    >
                                                        Branch:
                                                    </div>
                                                    <div>
                                                        {{ student.branch }}
                                                    </div>
                                                </v-layout>
                                                <v-layout row class="mb-2">
                                                    <div
                                                        class="font-weight-medium mr-2"
                                                    >
                                                        Grade:
                                                    </div>
                                                    <div>
                                                        {{ student.class }}
                                                    </div>
                                                </v-layout>
                                                <v-layout row class="mb-2">
                                                    <div
                                                        class="font-weight-medium mr-2"
                                                    >
                                                        Section:
                                                    </div>
                                                    <div>
                                                        {{ student.section }}
                                                    </div>
                                                </v-layout>
                                                <v-layout row class="mb-2">
                                                    <div
                                                        class="font-weight-medium mr-2"
                                                    >
                                                        Building:
                                                    </div>
                                                    <div>
                                                        {{ student.building }}
                                                    </div>
                                                </v-layout>
                                                <v-layout row class="mb-2">
                                                    <div
                                                        class="font-weight-medium mr-2"
                                                    >
                                                        Address:
                                                    </div>
                                                    <div>
                                                        {{ student.address1 }}
                                                    </div>
                                                </v-layout>
                                                <v-layout row class="mb-2">
                                                    <div
                                                        class="font-weight-medium mr-2"
                                                    >
                                                        Home Phone:
                                                    </div>
                                                    <div>
                                                        {{ student.homePhone }}
                                                    </div>
                                                </v-layout>
                                                <v-layout row class="mb-2">
                                                    <div
                                                        class="font-weight-medium mr-2"
                                                    >
                                                        Cell Phone:
                                                    </div>
                                                    <div>
                                                        {{ student.cellPhone }}
                                                    </div>
                                                </v-layout>
                                            </div>
                                        </div>
                                    </v-card-text>
                                </v-layout>
                            </v-layout>

                            <v-spacer></v-spacer>

                            <!-- <v-layout
                        align-end
                        justify-space-between
                        column
                        fill-height
                        class="mb-0 mr-2"
                    >
                        <v-btn
                            class="mt-0 mb-3 mr-1"
                            color="success"
                            small
                            dark
                            @click="openEditDialog"
                        >
                            Edit
                        </v-btn>
                    </v-layout> -->
                        </v-card>
                    </v-flex>
                    <v-flex xs9>
                        <v-card
                            style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
                        >
                            <v-layout row class="ma-0 pa-0">
                                <v-layout column class="ma-1 px-3 mt-2">
                                    <v-text-field
                                        v-model="mother"
                                        label="Mother"
                                    ></v-text-field>
                                    <v-text-field
                                        v-model="motherCellphone"
                                        label="Mother Cellphone"
                                    ></v-text-field>
                                    <v-text-field
                                        v-model="referral"
                                        label="Referral"
                                    ></v-text-field>
                                    <v-text-field
                                        v-model="concern"
                                        label="Concern"
                                    ></v-text-field>
                                    <v-text-field
                                        v-model="workDone"
                                        label="What was done until now"
                                    ></v-text-field>
                                    <v-combobox
                                        v-model="status"
                                        label="Status"
                                        :items="statuses"
                                    ></v-combobox>
                                    <v-text-field
                                        v-model="statusReason"
                                        label="Status Reason"
                                    ></v-text-field>
                                    <v-text-field
                                        v-model="process"
                                        label="Process"
                                    ></v-text-field>
                                </v-layout>
                                <v-layout column class="ma-1 px-3 mt-2">
                                    <v-menu
                                        v-model="datePickerMenu"
                                        :close-on-content-click="true"
                                        offset-y
                                        full-width
                                        prepend-icon="mdi-currency-usd"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                v-model="evaluationDate"
                                                label="Evaluation Date"
                                                prepend-icon="mdi-calendar"
                                                class="mb-2"
                                                v-on="on"
                                                hide-details
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="evaluationDate"
                                        ></v-date-picker>
                                    </v-menu>
                                    <v-text-field
                                        v-model="evaluatedBy"
                                        label="Evaluated By"
                                    ></v-text-field>
                                    <v-text-field
                                        v-model="evaluationOutcome"
                                        label="Evaluation Outcome"
                                    ></v-text-field>
                                    <v-text-field
                                        v-model="parentsInput"
                                        label="Parents Input"
                                    ></v-text-field>
                                    <v-text-field
                                        v-model="teachersInput"
                                        label="Teachers Input"
                                    ></v-text-field>
                                    <v-text-field
                                        v-model="otherRecommendations"
                                        label="Other Recommendations (What else was recommended, by whom, progress)"
                                    ></v-text-field>
                                    <v-combobox
                                        v-model="provider"
                                        label="Provider"
                                        ref="provider"
                                        :items="providers"
                                        :rules="[rules.required]"
                                    ></v-combobox>
                                    <v-menu
                                        ref="timeOfService"
                                        v-model="timePickerMenu"
                                        :close-on-content-click="false"
                                        :return-value.sync="timeOfService"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                v-model="timeOfService"
                                                label="Time Of Service"
                                                class="pr-1"
                                                readonly
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-time-picker
                                            width="290"
                                            v-model="timeOfService"
                                            @input="saveTimeOfService($event)"
                                        ></v-time-picker>
                                    </v-menu>
                                    <v-text-field
                                        v-model="roomNumber"
                                        label="Room Number"
                                    ></v-text-field>
                                </v-layout>
                            </v-layout>
                            <v-card-actions class="pb-3 pt-0">
                                <v-spacer></v-spacer>
                                <v-btn color="default" dark @click="cancel()"
                                    >Cancel</v-btn
                                >
                                <v-btn
                                    :loading="processing"
                                    color="success"
                                    @click="save()"
                                    >Save</v-btn
                                >
                            </v-card-actions>
                        </v-card>
                    </v-flex></v-layout
                >
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import { groupBy, formatPhoneNumber } from "../../utils/helpers.js";
import moment from "moment";

export default {
    data: () => ({
        student: null,
        processing: false,
        loadingStudent: true,

        statuses: [],

        referral: "",
        concern: "",
        evaluatedBy: "",
        evaluationOutcome: "",
        otherRecommendations: "",
        parentsInput: "",
        teachersInput: "",
        process: "",
        provider: "",
        status: "",
        statusReason: "",
        updatedAt: "",
        updatedBy: "",
        workDone: "",
        mother: "",
        motherCellphone: "",
        datePickerMenu: false,
        timePickerMenu: false,
        timeOfService: "",
        evaluationDate: "",
        roomNumber: "",
        providers: [],

        rules: {
            required: (v) => {
                return !!v || "Required";
            },
        },
    }),
    async created() {
        await this.load();
        await this.loadStatuses();
        await this.loadProviders();
    },
    methods: {
        async load() {
            await this.loadStudent();
            await this.loadSpatialNeedsInfo();
        },
        async loadStudent() {
            const student = await this.$http.get(
                "api/students/getStudent?studentID=" + this.$route.params.id
            );

            this.student = student;
            this.loadingStudent = false;
        },
        async loadSpatialNeedsInfo() {
            const info = await this.$http.get(
                "api/specialNeedsProgram/getStudent?studentID=" +
                    this.$route.params.id
            );

            if (info) {
                this.$router.push({
                    name: "SpecialNeedsStudentView",
                    params: { id: this.$route.params.id },
                });
            }
        },
        async loadStatuses() {
            const statuses = await this.$http.get(
                "api/specialNeedsProgram/getStatuses"
            );

            this.statuses = statuses.filter(Boolean);
        },
        async loadProviders() {
            let providers = await this.$http.get(
                "api/specialNeedsProgram/getProviders"
            );

            providers = providers.filter(Boolean);

            if (this.isProvider()) {
                providers = [this.$store.state.authentication.user];
            }

            this.providers = providers;
        },
        isProvider() {
            const roles = Array.isArray(this.$store.state.authentication.roles)
                ? this.$store.state.authentication.roles
                : this.$store.state.authentication.roles
                ? this.$store.state.authentication.roles.split(",")
                : [];

            return roles.includes("Special Needs Provider");
        },
        saveTimeOfService(value) {
            this.$refs.timeOfService.save(value);
        },
        cancel() {
            this.$router.push({
                name: "StudentView",
                params: { id: this.$route.params.id },
            });
        },
        async save() {
            try {
                if (!this.$refs.provider.validate(true)) return;

                this.processing = true;

                await this.$http.post("api/specialNeedsProgram/save", {
                    studentID: this.student.studentID,
                    familyID: this.student.familyID,
                    referral: this.referral,
                    concern: this.concern,
                    workDone: this.workDone,
                    status: this.status,
                    workStatus: "Active",
                    statusReason: this.statusReason,
                    process: this.process,
                    evaluatedBy: this.evaluatedBy,
                    evaluationOutcome: this.evaluationOutcome,
                    parentsInput: this.parentsInput,
                    teachersInput: this.teachersInput,
                    otherRecommendations: this.otherRecommendations,
                    provider: this.provider,
                    timeOfService: this.timeOfService,
                    evaluationDate: this.evaluationDate,
                    roomNumber: this.roomNumber,
                    updatedBy: this.$store.state.authentication.user,
                });

                this.$notify({
                    text: "Student Saved",
                    group: "notification",
                    type: "success",
                });

                this.processing = false;

                this.$router.push({
                    name: "SpecialNeedsStudentView",
                    params: { id: this.$route.params.id },
                });
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
.v-expansion-panel__header {
    height: 63px;
}
.distribution-list {
    border: 1px solid #ddd !important;
}
</style>
